import React from "react";
import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Typography,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { Form, FormItem, TextField } from "../../components";
import { useSaveTemplateDialog } from "./SaveTemplateDialog.hooks";
import { SaveTemplateDialogProps } from "./SaveTemplateDialog.types";

function SaveTemplateDialog(props: SaveTemplateDialogProps): JSX.Element {
  const { open, onClose } = props;

  const { form, save, saving, errorMessage, closeError } =
    useSaveTemplateDialog(props);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      disableEscapeKeyDown={saving}
    >
      <DialogTitle>
        <Typography variant="h3" component="p" color="black" my={2}>
          Save template
        </Typography>
      </DialogTitle>
      <DialogContent>
        {errorMessage && (
          <Box mb={5} mt={1}>
            <Alert variant="filled" severity="warning" onClose={closeError}>
              {errorMessage}
            </Alert>
          </Box>
        )}
        <Typography component="p" variant="label2" color="grey" mt={0} mb={5}>
          Please provide a template name to save your changes
        </Typography>
        <Box pt={2}>
          <Form form={form} onSubmit={save}>
            <FormItem
              name="name"
              rules={{
                required: {
                  value: true,
                  message: "Template name is required.",
                },
                maxLength: {
                  value: 256,
                  message: "Template name must be less than 256 characters.",
                },
              }}
            >
              <TextField
                placeholder="Enter template name"
                label="Template name"
                hiddenLabel
              />
            </FormItem>
          </Form>
        </Box>
        <Box mt={5}>
          <Divider />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          variant="text"
          color="primary"
          onClick={onClose}
          disabled={saving}
        >
          Cancel
        </Button>
        <LoadingButton
          variant="contained"
          color="primary"
          onClick={save}
          loading={saving}
          disabled={saving}
        >
          Save
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}

export default SaveTemplateDialog;
